function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import TypeUtils from "./type";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "htmlUrl",
    value: function htmlUrl(originalUrl) {
      if (TypeUtils.isString(originalUrl)) {
        var url;

        if (originalUrl.indexOf("?") > -1) {
          url = originalUrl.replace(/.json\?/, "?");
        } else {
          url = originalUrl.replace(/.json$/, "");
        } // As much as possible, try retaining the front fragment by matching the back, because
        // the front could be either a `?` or `&`


        url = url.replace(/format=json\&/, ""); // If no match, then we replace the front fragment

        url = url.replace(/[\&\?]format=json/, "");
        return url;
      }

      return "";
    }
  }, {
    key: "jsonUrl",
    value: function jsonUrl(originalUrl) {
      if (typeof originalUrl === "string") {
        var url = originalUrl;

        if (originalUrl.indexOf("?") > -1) {
          if (originalUrl.indexOf(".json?") == -1 && originalUrl.search(/[\&\?]format=json/) == -1) {
            url = originalUrl + "&format=json";
          }
        } else {
          if (!originalUrl.endsWith(".json")) {
            url = originalUrl + "?format=json";
          }
        }

        return url;
      }

      return "";
    }
  }, {
    key: "toFormData",
    value: function toFormData(params) {
      var formData = new FormData();

      for (var key in params) {
        formData.append(key, params[key]);
      }

      return formData;
    }
  }, {
    key: "toMap",
    value: function toMap(formData) {
      return this._extractUrlParams(new URLSearchParams(formData).toString());
    }
  }, {
    key: "appendParams",
    value: function appendParams(url, params) {
      if (params instanceof FormData) {
        var queryString = new URLSearchParams(params).toString();

        if (queryString.length <= 0) {
          return url;
        }

        if (url.contains("?")) {
          return url + "&".concat(queryString);
        } else {
          return url + "?".concat(queryString);
        }
      } else {
        return this.appendParams(url, this.toFormData(params)); // throw "Invalid params"
      }
    } // static asQueryString(obj) {
    //   if (!TypeUtils.isObject(obj)) {
    //     return ""
    //   }
    //
    //   var str = [];
    //   for (var p in obj) {
    //     if (obj.hasOwnProperty(p)) {
    //       str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
    //     }
    //   }
    //   return str.join("&")
    // }

  }, {
    key: "extractFormActionData",
    value: function extractFormActionData(originalUrl, local) {
      if (typeof originalUrl === "string") {
        var substitute = local ? "" : ".json";
        var url;

        if (originalUrl.indexOf("?") > -1) {
          url = originalUrl.replace(/.json\?.*/, substitute);
        } else {
          url = originalUrl.replace(/.json$/, substitute);
        }

        return {
          url: url,
          params: this._extractUrlParams(originalUrl)
        };
      }

      return {};
    } // // https://gist.github.com/pirate/9298155edda679510723

  }, {
    key: "_extractUrlParams",
    value: function _extractUrlParams(search) {
      var _this = this;

      var hashes = search.slice(search.indexOf("?") + 1).split("&");
      return hashes.reduce(function (params, hash) {
        var split = hash.indexOf("=");

        if (split < 0) {
          return Object.assign(params, _defineProperty({}, hash, null));
        }

        var name = hash.slice(0, split);
        var val = hash.slice(split + 1);
        var key = decodeURIComponent(name);

        if (key.endsWith("[]")) {
          if (params[key]) {
            params[key].push(val);
            return params;
          } else {
            return Object.assign(params, _defineProperty({}, key, [_this._decodeParamValue(val)]));
          }
        } else {
          return Object.assign(params, _defineProperty({}, key, _this._decodeParamValue(val)));
        }
      }, {});
    }
  }, {
    key: "_decodeParamValue",
    value: function _decodeParamValue(value) {
      // See https://stackoverflow.com/questions/18717557/remove-plus-sign-in-url-query-string/24417399
      var encodedSpaces = value.replace(/\+/g, "%20");
      return decodeURIComponent(encodedSpaces);
    }
  }]);

  return _default;
}();

export { _default as default };